<template>
  <HeadingLv1 text="お気に入り病院一覧" />
  <div class="u-containar">
    <MypageContents>
      <TabSeminar
        :list="tab"
        :current="state.currentTab"
        @click-tab="clickTab"
        class="s_tab"
      />

      <div v-if="state.currentTab === 0">
        <Loader v-if="state.isLoading" />

        <template v-if="!state.isLoading">
          <div class="reqBtn" v-if="state.hasRequestableHospital">
            <Button
              :label="
                !state.enableRequest
                  ? 'まとめて資料請求'
                  : 'まとめて資料請求をやめる'
              "
              :handleClick="changeRequestEnable"
              :primary="!state.enableRequest"
            />
          </div>
          <div class="favoriteHospital" v-if="list.length > 0">
            <template v-for="(item, i) in list" :key="i">
              <HospitalCassette
                :detail="item"
                :enable-request="state.enableRequest"
                @call-input-change="changeCheckbox"
              />
            </template>
          </div>
          <NothingArea
            v-if="list.length == 0"
            :label="'お気に入りに登録'"
            :items="list_recommend"
          />
          <BackTo :link="'/mypage'" />
        </template>

        <div class="fixedArea" v-if="state.enableRequest">
          <Button label="やめる" :handleClick="changeRequestEnable" />
          <Button
            :emlabel="ckeckedList.length > 0 ? `${ckeckedList.length}件` : ''"
            :label="
              ckeckedList.length > 0 ? `の病院へ資料請求する` : '資料請求する'
            "
            :handleClick="toReqDocs"
            :disabled="ckeckedList.length === 0"
            primary
          />
        </div>
      </div>

      <div v-if="state.currentTab === 1">
        <Loader v-if="state.s_isLoading" />

        <template v-if="!state.s_isLoading">
          <div class="reqBtn" v-if="state.s_hasRequestableHospital">
            <Button
              :label="
                !state.s_enableRequest
                  ? 'まとめて資料請求'
                  : 'まとめて資料請求をやめる'
              "
              :handleClick="changeRequestEnable_s"
              :primary="!state.s_enableRequest"
            />
          </div>
          <div class="favoriteHospital" v-if="list_s.length > 0">
            <template v-for="(item, i) in list_s" :key="i">
              <HospitalCassetteSeminar
                :detail="item"
                :enable-request="state.s_enableRequest"
                @call-input-change="changeCheckbox_s"
              />
            </template>
          </div>
          <Alert
            v-if="list_s.length == 0"
            text="お気に入りに登録している病院はありません"
          />
          <BackTo :link="'/mypage'" />
        </template>

        <div class="fixedArea" v-if="state.s_enableRequest">
          <Button label="やめる" :handleClick="changeRequestEnable_s" />
          <Button
            :emlabel="
              ckeckedList_s.length > 0 ? `${ckeckedList_s.length}件` : ''
            "
            :label="
              ckeckedList_s.length > 0 ? `の病院へ資料請求する` : '資料請求する'
            "
            :handleClick="toReqDocs_s"
            :disabled="ckeckedList_s.length === 0"
            primary
          />
        </div>
      </div>
    </MypageContents>
  </div>
</template>

<script lang="ts">
import { useStore } from 'vuex'
import { computed, onMounted, reactive, defineComponent } from 'vue'
import Alert from '@/components/elements/Alert.vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import TabSeminar from '@/components/elements/TabSeminar.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'
import HospitalCassetteSeminar from '@/components/block/HospitalCassetteSeminar.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRouter } from 'vue-router'
import NothingArea from '@/components/block/NothingArea.vue'
import BackTo from '@/components/block/BackTo.vue'
import Loader from '@/components/elements/Loader.vue'

export default defineComponent({
  name: 'BookmarkList',

  components: {
    Alert,
    Button,
    HeadingLv1,
    TabSeminar,
    MypageContents,
    HospitalCassette,
    HospitalCassetteSeminar,
    NothingArea,
    BackTo,
    Loader
  },

  setup() {
    const router = useRouter()
    const list = reactive<any>([])
    const list_recommend = reactive<any>([])
    const list_s = reactive<any>([])
    const store = useStore()
    const userInfo = store.state.userInfo
    const state = reactive<any>({
      currentTab: userInfo.member_type === '医学生' ? 0 : 1,
      enableRequest: false,
      s_enableRequest: false,
      hasRequestableHospital: false,
      s_hasRequestableHospital: false,
      isLoading: true,
      s_isLoading: true
    })

    const ckeckedList = reactive<any>([])
    const ckeckedList_s = reactive<any>([])

    const changeCheckbox = (ev: Record<string, boolean>) => {
      if (ev.checked) {
        ckeckedList.push(ev.value)
      } else {
        ckeckedList.splice(ckeckedList.indexOf(ev.value), 1)
      }
    }

    const changeCheckbox_s = (ev: Record<string, boolean>) => {
      if (ev.checked) {
        ckeckedList_s.push(ev.value)
      } else {
        ckeckedList_s.splice(ckeckedList_s.indexOf(ev.value), 1)
      }
    }

    const changeRequestEnable = () => {
      state.enableRequest = state.enableRequest ? false : true
      ckeckedList.splice(0)
    }

    const changeRequestEnable_s = () => {
      state.s_enableRequest = state.s_enableRequest ? false : true
      ckeckedList_s.splice(0)
    }

    const toReqDocs = () => {
      const ids = ckeckedList.join('_')
      const url = `/document_request/${ids}/input`

      router.push({ path: url })
    }

    const toReqDocs_s = () => {
      const ids = ckeckedList_s.join('_')
      const url = `/document_request_latter/${ids}/input`

      router.push({ path: url })
    }

    const tab = computed(() => {
      return [
        {
          label: '病院・初期研修',
          name: 'first'
        },
        {
          label: '専門研修',
          name: 'second'
        }
      ]
    })

    const clickTab = (i: number) => {
      state.currentTab = i
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      getList
        .get('/api/v1/favorite_list')
        .then((res) => {
          res.data.forEach((item: any) => {
            list.push(item)

            if (item.active_flg === 3 && item.paid_flg === 1) {
              state.hasRequestableHospital = true
            }
          })

          if (res.data.length == 0) {
            getList
              .get('/api/v1/j_search/recommend')
              .then((res_recommend) => {
                res_recommend.data.forEach((item: any) => {
                  list_recommend.push(item)
                })
              })
              .then(() => {
                state.isLoading = false
              })
          } else {
            state.isLoading = false
          }
        })
        .catch(() => {
          state.isLoading = false
        })

      getList
        .get('/api/v1/s_favorite_list')
        .then((res) => {
          res.data.forEach((item: any) => {
            list_s.push(item)

            if (item.active_flg === 3 && item.paid_flg === 1) {
              state.s_hasRequestableHospital = true
            }
          })
          state.s_isLoading = false
        })
        .catch(() => {
          state.s_isLoading = false
        })
    })

    return {
      list,
      list_recommend,
      list_s,
      state,
      tab,
      changeRequestEnable,
      changeRequestEnable_s,
      toReqDocs,
      toReqDocs_s,
      changeCheckbox,
      changeCheckbox_s,
      ckeckedList,
      ckeckedList_s,
      clickTab
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.s_tab {
  margin-bottom: 30px;
  @include mixins.media() {
    margin-bottom: 24px;
  }
}

.favoriteHospital {
  margin-top: 33px;
  margin-bottom: 56px;
}

.reqBtn {
  @include mixins.media() {
    .button {
      margin-right: 0;
    }
  }
}

::v-deep(.headingLv2) {
  margin-top: 50px;
  margin-bottom: 35px;

  & + .button {
    max-width: 88%;
  }
}

.fixedArea {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  z-index: 100;
  height: 72px;
  background: #fff;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fixedArea .button {
  margin-left: 8px;
  margin-right: 8px;
  max-width: 224px;

  &:first-child {
    flex-shrink: 2;
  }

  &:last-child {
    flex-grow: 1;
  }
}

// ::v-deep(.goalButtons) {
//   position: fixed;
//   bottom: 55px;
//   width: 100%;
//   padding-right: 15px;
//   padding-left: 15px;
//   background: #fff;
//   z-index: 100;
// }

// .fixedArea

// ::v-deep(.goalButtons .button) {
//   max-width: none;
//   flex-basis: 85px;
//   flex-grow: 0;
//   width: auto;
// }

// ::v-deep(.goalButtons .button.primary) {
//   flex-grow: 1;
// }
</style>
